import { render, staticRenderFns } from "./OpenboxUpload.vue?vue&type=template&id=c331b70e&"
import script from "./OpenboxUpload.vue?vue&type=script&lang=js&"
export * from "./OpenboxUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports